const actions = {
  FETCH_SUPPORT_DOCUMENTS: 'FETCH_SUPPORT_DOCUMENTS',
  FETCH_SUPPORT_DOCUMENTS_SUCCESS: 'FETCH_SUPPORT_DOCUMENTS_SUCCESS',
  FETCH_SUPPORT_DOCUMENTS_ERROR: 'FETCH_SUPPORT_DOCUMENTS_ERROR',
  fetchDocuments: () => ({
    type: actions.FETCH_SUPPORT_DOCUMENTS,
  }),
};
export default actions;
